export const NODE_TYPES = {
  heading1: 'heading1',
  heading2: 'heading2',
  heading3: 'heading3',
  heading4: 'heading4',
  heading5: 'heading5',
  heading6: 'heading6',
  paragraph: 'paragraph',
  preformatted: 'preformatted',
  strong: 'strong',
  em: 'em',
  listItem: 'list-item',
  oListItem: 'o-list-item',
  list: 'group-list-item',
  oList: 'group-o-list-item',
  image: 'image',
  embed: 'embed',
  hyperlink: 'hyperlink',
  label: 'label',
  span: 'span'
};
export const NODE_ELEMENTS = {
  [NODE_TYPES.heading1]: 'h1',
  [NODE_TYPES.heading2]: 'h2',
  [NODE_TYPES.heading3]: 'h3',
  [NODE_TYPES.heading4]: 'h4',
  [NODE_TYPES.heading5]: 'h4',
  [NODE_TYPES.heading6]: 'h6',
  [NODE_TYPES.paragraph]: 'p',
  [NODE_TYPES.strong]: 'strong',
  [NODE_TYPES.em]: 'em',
  [NODE_TYPES.listItem]: 'li',
  [NODE_TYPES.oListItem]: 'li',
  [NODE_TYPES.list]: 'ul',
  [NODE_TYPES.oList]: 'ol',
  // [NODE_TYPES.image]: 'img',
  // [NODE_TYPES.embed]: 'embed',
  [NODE_TYPES.hyperlink]: 'a',
  [NODE_TYPES.label]: 'span'
};